import React from 'react';
import PropTypes from 'prop-types';
import { MobileText, DesktopText } from './styles.js';

export const ResponsiveText = ({ mobileText, desktopText }) => {
  return (
    <>
      <MobileText>{mobileText}</MobileText>
      <DesktopText>{desktopText}</DesktopText>
    </>
  );
};
ResponsiveText.displayName = 'ResponsiveText';
ResponsiveText.propTypes = {
  mobileText: PropTypes.string.isRequired,
  desktopText: PropTypes.string.isRequired,
};
